import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { connect } from 'react-redux';
import {setHeadersForFetch} from '../../objects/CommonUse/set_headers_for_fetch';
import {doubleToStringMonthly} from '../../objects/CommonUse/double_functions';
import replaceTextInString from '../../objects/CommonUse/replace_text_in_string';
import CreditCardSetupIntro from './text/credit_card_setup_intro_text';
import ConfigFile from '../../datasets/config_file';
import CreditCardPaymentPolicy from './datasets/credit_card_payment_policy';
import CreditCardParameters from './datasets/credit_card_parameters';
import FriendDisplayModal from '../shared-components/friend_display_modal';
import { reformatDateToDisplay } from '../../objects/CommonUse/reformatDateToDisplay_function';
import {findDataObject} from '../../objects/CommonUse/find_data_object';
import DropDownOptionCard from '../shared-components/drop_down_option_card';
import {buildUrl } from '../../objects/CommonUse/build_URL';
import Config from '../../config';
import { rollForwardDate } from './objects/roll_forward_date_function';
import createEventTrackerUpdateObject from '../../objects/CommonUse/create_eventTracker_update_object';
import calculatePaymentHistory from './objectsEndOfTurn/calculate_payment_history';
import determineCreditScore from './objectsEndOfTurn/determine_credit_score';
import updateSessionTokenStorage from '../../pages/Objects/update_session_token_storage';

// mapStateToProps: pick the Redux state your component needs
const mapStateToProps = (state) => ({
    gameInfo: state,
    gameData: state.gameData,
    creditCardInfo: state.creditCardInfo,
    timeWizardInfo: state.timeWizardInfo,
  
    // add other Redux state slices here if needed
});

class SetupCreditCardModal extends Component {
            constructor(props) {
              super(props);
              this.gameInfo = JSON.parse(JSON.stringify(this.props.gameInfo));
              this.creditCardInfo = JSON.parse(JSON.stringify(this.props.creditCardInfo));
              this.gameData = JSON.parse(JSON.stringify(this.props.gameData));
              this.timeWizardInfo = JSON.parse(JSON.stringify(this.props.timeWizardInfo))
              this.state={
                headers: setHeadersForFetch(),  
                displayInfo: true,
                defaultClass: "font-weight-bold ",
                openFriendModal: false,
                rerender: false,
                subProcess: "setupCreditCardModal",
                environment: Config.dataURL.currentEnv,
                eventTracker: ConfigFile.general.eventTracker,
                paymentAmount: "0"
              }   
        this.step = "display";
        this.creditCardOptionArr = [];
        this.updateEnabled = false;
        this.creditCardStatus = "";
        this.changeType = this.props.changeType;
        this.initializeFields();
    }
    
    initializeFields(){
        this.prePopulateAmounts();
        this.introText();
        if (this.creditCardInfo.totalOutstandingBalance &&
            this._isMounted === true){
            this.setState({displayInfo: false});
        }
        this.acceptDeclineClass = this.state.defaultClass;
        this.paymentPolicyClass = this.state.defaultClass;
        this.paymentAmountClass = this.state.defaultClass;
        switch (this.changeType){
            case "payment":
                this.title = "Make a Payment";
                this.step = "payment";
                this.creditCardPaymentText = "";
                if (this.props.eligible === false){
                    this.creditCardPaymentText = "You will need to make a payment " +
                        "in order to be eligible for a higher credit limit."
                }
                break;
            case "policy": 
                this.title = "Change Credit Card Policy";
                this.step = "change";
                break;
            case "newLevel":
                this.title = "Accept/Decline New Credit Limit & Review Policy";
                this.step = "display";
                break; 
            default:
                break;
        }
        updateSessionTokenStorage("setupCreditCard");
    }

    prePopulateAmounts(){
        let unlockedFeature = 
            this.gameData.unlockedFeatures.find(elem => elem.featureName === "creditCard");
        this.creditCardSetup = unlockedFeature.setup;
     
        this.newCardLevel = +unlockedFeature.level;
        if (this.creditCardInfo.cardLevel){
            this.currentCardLevel = +this.creditCardInfo.cardLevel;
        }else{
            this.currentCardLevel = 1;
        }
        if (this.props.eligible === false && 
            this.newCardLevel > this.creditCardInfo.cardLevel){
                this.newCardLevel = this.currentCardLevel;
                if (this.changeType !== "payment"){
                    this.newCreditLimitLit = "You’re no longer eligible for the new credit limit. " +
                        "You can update the payment policy for the current level. ";
                }else{
                    this.newCreditLimitLit = "Please make a payment to reinstate your eligibility " +
                        "for a higher credit limit.";
                }
        }
        
        if (!this.creditCardInfo.gameID || 
            this.creditCardInfo.currentlyActive === false){
                this.creditCardAlreadySetup = false;
                this.currentOutstandingBalance = 0;
                this.paymentPolicy = "No payment policy has been set."; 
                this.creditCardStatus = "newCreditCard";
                this.currentCardLevel = this.newCardLevel; 
                let indx = this.newCardLevel - 1;   
                this.newCreditLimitAmt = CreditCardParameters[indx].maxCreditCardAmt;       
        }else{
                this.creditCardAlreadySetup = true;
                this.currentCardLevel = +this.creditCardInfo.cardLevel;
                if (this.currentCardLevel === this.newCardLevel){
                    this.creditCardStatus = "cardActive";
                }else{
                    let indx = this.newCardLevel - 1;
                    this.newCreditLimitAmt = CreditCardParameters[indx].maxCreditCardAmt; 
                    this.creditCardStatus = "newLevel";
                    this.newCreditLimitLit = "Congratulations!  You have been approved for a new credit limit. " +
                        "The new credit limit is " + doubleToStringMonthly(this.newCreditLimitAmt);
                }
        }
        this.populateCreditCardInfoFields();
        this.currentCreditLimitAmt = CreditCardParameters[this.currentCardLevel - 1].maxCreditCardAmt;
        this.setCreditCardOptions();
    }

    setCreditCardOptions(){
        this.creditCardOptionArr = [{value: "none", selection: "no option selected"}];
        var newObj;
        switch (this.creditCardStatus){
            case "newCreditCard":
                this.btnText = "Accept/Decline Credit Card";
                newObj = {value: "accept", selection: "Activate the Credit Card"};
                this.creditCardOptionArr.push(newObj);
                newObj = {value: "decline", selection: "Decline the Credit Card"};
                this.creditCardOptionArr.push(newObj);
                break;
            case "cardActive":
                this.btnText = "Change Credit Card Policy";
                newObj = {value: "retain", selection: "Retain the Credit Card"};
                this.creditCardOptionArr.push(newObj);
                newObj = {value: "decline", selection: "De-activate the Credit Card"};
                this.creditCardOptionArr.push(newObj);
                break;
            case "newLevel":
                this.btnText = "Accept/Decline Credit Card";
                newObj = {value: "accept", selection: "Activate New Level"};
                this.creditCardOptionArr.push(newObj);
                newObj = {value: "retainCurrent", selection: "Keep Current Card, Decline New Level"};
                this.creditCardOptionArr.push(newObj);
                newObj = {value: "decline", selection: "De-activate Credit Card, Decline New Level" }
                this.creditCardOptionArr.push(newObj);
                break;
            default:
                break;
        }
    }    

    populateCreditCardInfoFields(){
        if (!this.creditCardInfo.totalOutstandingBalance){
            this.currentOutstandingBalance = 0;
        }else{
            this.currentOutstandingBalance = (+this.creditCardInfo.totalOutstandingBalance).toFixed(2);
        }
        this.initialAcceptDecline = this.creditCardSetup;
        this.paymentPolicyCode = this.creditCardInfo.paymentPolicyCode;
        let paymentPolicyObj = 
                CreditCardPaymentPolicy.find(elem => elem.paymentPolicyCode === this.paymentPolicyCode);
        if (!paymentPolicyObj){
            this.paymentPolicy = "none";
        }else{
            this.paymentPolicy = paymentPolicyObj.desc;
        }
        this.minPayPct = +ConfigFile.unlockedFeatures.creditCardMinimumPayPct;
        this.minimumPaymentAmt = this.currentOutstandingBalance * this.minPayPct;
    }

    introText(){
        this.introText1 = CreditCardSetupIntro[0];
        let introText2 = CreditCardSetupIntro[1];
        this.creditCardInterest = (ConfigFile.unlockedFeatures.creditCardInterest * 100) + "%";
        let replaceObj = {amount: this.currentCreditLimitAmt, number: this.creditCardInterest};
        this.introText2 = replaceTextInString(introText2, replaceObj);
    }

        
    displayFriendModal(){
        this.askAFriendInfo = {topic: "setupCreditCard"};
        this.setState({openFriendModal: true});
    }

    closeFriendModal(){
        this.setState({openFriendModal: false});
    }

    collapseInfoDisplay(){
        this.setState({displayInfo: false});
    }

    expandInfoDisplay(){
        this.setState({displayInfo: true});
    }

    changeCreditCardPolicy(){
        this.step = "change";
        this.title = "Setup Or Change Credit Card Policy";
        this.setState({displayInfo: false});
    }

    goBackToPaymentOption(){
         this.step = "payment";
         this.title = "Make a Payment";
         this.setState({displayInfo: false});
    }
    
    payFullAmt(){
        this.setState({paymentAmount: this.currentOutstandingBalance})
    }

    handlePaymentChange = (e) => {
        this.setState({paymentAmount: e.target.value});
    };

    editFormFields(){
        this.validEntries = true;
        this.getFormEntries();
        // edits done in reverse display order so messages will come out in correct order
       
        this.editPaymentPolicy();
        this.editCreditCardSetup();
        if (this.currentOutstandingBalance > 0){
            this.editPaymentAmount();
        }else{
            this.paymentAmount = 0;
        }
        this.confirmChangeWasMade();
        if (this.validEntries === true){
            this.setNewPaymentPolicy();
            if (this.step === "payment"){
                this.step = "paymentConfirm";
            }else{
                this.step = "confirm";
            }
            this.outStandingMsg = "";
            if (this.acceptDecline === "retain"){
                this.newCreditLimitAmt = this.currentCreditLimitAmt;
            }else{
                if (this.acceptDecline === "decline"){
                    this.newCreditLimitAmt = 0;
                    this.newPaymentPolicy = "Credit Card will be declined/cancelled. " 
                    if (this.currentOutstandingBalance > 0 && 
                       this.state.paymentAmount < this.currentOutstandingBalance){
                       this.outStandingMsg = "The Outstanding Balance (" + 
                            doubleToStringMonthly(this.currentOutstandingBalance) 
                            + ") on Card Must be Paid or Late Fees will be charged."
                    }else{
                        this.outStandingMsg = "";
                    }
                }
            }
            this.creditCardPolicyComplete = true;
            this.message = "Entries valid.  Click Confirm Change to save changes."
            this.msgClass = "";
            this.updateEnabled = true;
            this.setState({rerender: true});
        }else{
            this.msgClass = this.state.defaultClass + " text-danger";
            this.setState({rerender: false});
        }
    }

    getFormEntries(){
        this.changeType = this.props.changeType;
        if (this.step !== "payment" && this.step !== "paymentConfirm"){
            this.acceptDecline = document.getElementById("acceptDecline").value;
        }else{
            if (this.creditCardInfo.currentlyActive === true){
                this.acceptDecline = "retain"; 
            }else{
                this.acceptDecline = "decline";
            }
        }
        if (this.changeType === "policy" || this.changeType === "newLevel"){
            if (this.changeType === "newLevel"){
                this.cardLit = "Do you want to activate the New Credit Card?: "
            }else{
                this.cardLit = "Do you want to keep the Credit Card?: "
            }
            if (this.acceptDecline === "accept"){
                this.setupCreditCardSw = true;
                this.creditCardSetup = "Yes"
            }else{
                this.setupCreditCardSw = false;
                if (this.acceptDecline === "decline"){
                    this.creditCardSetup = "No, Cancel credit card."
                }else{
                    this.creditCardSetup = "Yes, Retain the Current Credit Card Limit";
                }
            }
        }
        if (this.step !== "payment"){
            this.newPaymentPolicyCode = document.getElementById("paymentPolicy").value;
        }else{
            this.newPaymentPolicyCode = this.paymentPolicyCode;
        }
    }

    editCreditCardSetup(){
        this.acceptDeclineClass = this.state.defaultClass;
        if (this.acceptDecline === "none"){
             this.validEntries = false;
             this.acceptDeclineClass = this.state.defaultClass + "text-danger";
             this.message = "Must accept or decline Credit Card offer."
        }
        if (this.acceptDecline === "retain" && this.creditCardAlreadySetup === false){
            this.validEntries = false;
            this.acceptDeclineClass = this.state.defaultClass + "text-danger";
            this.message = "Current credit card policy has not been setup - cannot select 'keep' option."
        }
    }
    
    editPaymentPolicy(){
        if (this.acceptDecline === "retain" && this.creditCardInfo.paymentPolicyCode !== "" 
            && this.newPaymentPolicyCode === "none"){
                this.newPaymentPolicyCode = this.creditCardInfo.paymentPolicyCode;
        }
        if (this.acceptDecline !== "decline" && this.newPaymentPolicyCode === "none"){
            this.validEntries = false;
            this.paymentPolicyClass = this.state.defaultClass + "text-danger";
            this.message = "Must select a payment policy."
        }
        if (this.acceptDecline === "decline" && this.newPaymentPolicyCode !== "none"){
            this.validEntries = false;
            this.paymentPolicyClass = this.state.defaultClass + "text-danger";
            this.message = "Cannot select payment policy if declining the credit card."
        }
    }

    editPaymentAmount(){
        this.paymentAmountClass = this.state.defaultClass;
        this.paymentAmount = +this.state.paymentAmount;
        this.oneTimeTextType = "";
        if (this.paymentAmount > this.currentOutstandingBalance){
                this.validEntries = false;
                this.message = "Payment Amt cannot be greater than the current Outstanding Amt.";
                this.paymentAmountClass = this.state.defaultClass + " text-danger";
        }   
        if (this.step === "payment" && this.paymentAmount === 0){
                this.validEntries = false;
                this.message = "Payment amount of $0 is not valid when making a payment.";
                this.paymentAmountClass = this.state.defaultClass + " text-danger";
        }     
    }

    confirmChangeWasMade(){
        if (+this.paymentAmount === 0 && 
            this.newPaymentPolicyCode === this.creditCardInfo.paymentPolicyCode &&
            this.acceptDecline === "retain"){
                this.validEntries = false;
                this.message = "No Change has been made to the Credit Card Policy."
        }
    }

    setNewPaymentPolicy(){
        let paymentPolicyObj = 
            CreditCardPaymentPolicy.find(elem => elem.paymentPolicyCode === this.newPaymentPolicyCode);
        if (paymentPolicyObj){
            this.newPaymentPolicy = paymentPolicyObj.desc;
        }
    }
  
    render() {
        this.creditCardOptions = this.creditCardOptionArr.map((optionsList,index) =>
            <DropDownOptionCard options={optionsList} key={index} />
        );
       
                        
    return <>
      
      <Modal show={this.props.show}  onHide={() => this.props.onClose("none")} size="lg" scrollable="true"
            dialogClassName="gameview-modal-size" animation={false}>
        <Modal.Header className="backgroundTopBottom" closeButton>
          <Modal.Title className="text-center">{this.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
             <span>
                 {this.state.displayInfo ?
                    <span>
                        <div className="mx-4">
                            {this.introText1}
                        </div>
                        <div className="mx-4 mt-2">
                            {this.introText2}
                        </div>
                    </span>
                :
                    <div>Credit cards give you more flexibility in managing your money.</div>
                }
                {this.state.displayInfo ?
                    <div className="p-0 text-right">
                        <Button variant="outline-info" size="sm"
                            onClick={() => this.collapseInfoDisplay()}>
                            Collapse 
                        </Button>
                    </div>
                :
                    <div className="p-0 text-right">
                        <Button variant="outline-info" size="sm"
                            onClick={() => this.expandInfoDisplay()}>
                              Learn More
                        </Button>
                    </div>
                }    
                <span className="row-100">
                    <h5>Current Credit Card Information</h5>
                    <table>
                        <tbody>
                            <tr>
                                <th className="col-md-4">Statement Date:</th>
                                <td className="col-md-3 text-right">    
                                    {reformatDateToDisplay(this.gameData.currentGameDate)}</td>
                                <th className="col-md-6">Outstanding Credit Card Amt:</th>
                                <td className="col-md-3 text-right">
                                    {doubleToStringMonthly(this.currentOutstandingBalance)}</td>
                            </tr>
                            <tr>
                                <th className="col-md-4">Current Cash Amount:</th>
                                <td className="col-md-3 text-right">
                                    {doubleToStringMonthly(this.gameData.currentCash)}</td>
                                <th className="col-md-6">Mininum Payment Amount:</th>
                                <td className="col-md-3 text-right">
                                    {doubleToStringMonthly(this.minimumPaymentAmt)}</td> 
                            </tr>
                            <tr>
                                <th className="col-md-4">Credit Limit:</th>
                                <td className="col-md-3 text-right">
                                    {doubleToStringMonthly(this.currentCreditLimitAmt)}</td>
                                <th className="col-md-6">Fee Charged on Unpaid Amt:</th>
                                <td className="col-md-3 text-right">
                                    {this.creditCardInterest}</td> 
                            </tr>

                        </tbody>
                    </table>
                    <table>
                        <tbody>
                            <tr>
                                <th className="col-md-4">Current Payment Policy:</th>
                                <td className="col-md-8">{this.paymentPolicy}</td>
                            </tr>
                        </tbody>
                    </table>
                    {this.step !== "confirm" ?
                        <h6 className="mt-2 text-success">{this.newCreditLimitLit}</h6>
                    :
                        null
                    }
                </span>
                              
                {this.step === "change"  || this.step === "payment" ?
                    <span>
                        {this.currentOutstandingBalance > 0 ?
                            <div className="ml-4 mt-4">
                                <label className={this.paymentAmountClass} htmlFor="payAmt">
                                    Amount of Balance to Pay:&nbsp;&nbsp;</label>
                                <input type="text" className="col-med" id="payAmt" 
                                    value={this.state.paymentAmount}
                                    onChange={this.handlePaymentChange}
                                    name="payAmt"></input> 
                             
                                <button type="button" className="ml-4" size="sm" 
                                        onClick={() => this.payFullAmt()}>
                                            Pay Full Outstanding Amt
                                </button>
                            </div>
                        :
                            null
                        }
                        {this.changeType === "policy" || this.changeType === "newLevel" ?
                        <span>
                            <div className="font-weight-bold mt-2 text-center">
                                ------------------------------------- Credit Card Policy ---------------------------------------
                            </div>   
                            <div className="mt-2 mx-4">
                                <label className={this.acceptDeclineClass} htmlFor="acceptDecline">
                                    Do you want to accept the Credit Card? :&nbsp;&nbsp;</label>
                                <select className="btn btn-sm btn-outline-secondary dropdown-toggle" 
                                    id="acceptDecline">
                                   {this.creditCardOptions}
                                </select>
                            </div> 
                            <div className="mt-4 mx-4">
                                <label className={this.paymentPolicyClass} htmlFor="paymentPolicy">
                                    Select the preferred payment policy:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                                <select className="btn btn-sm btn-outline-secondary dropdown-toggle" 
                                    id="paymentPolicy">
                                    <option value="none">No payment policy selected</option>
                                    <option value="autoPayFull">Automatically pay the full balance each month</option>
                                    <option value="autoPayMin">Automatically pay the minimum balance each month</option>
                                    <option value="manualPay">Make manual payments on the card</option>
                                </select>
                            </div>                     
                        </span>
                        :
                            null
                        }
                    </span>
                :
                    null
                }

                {this.step === "confirm"  || this.step === "paymentConfirm" ?
                    <span className="ml-2 mt-4">
                        {this.currentOutstandingBalance > 0 ?
                            <div className="row ml-2">
                                <div className={this.paymentAmountClass}>
                                    Amount of Balance to Pay:</div>
                                <div className="col-sm-2">
                                    {doubleToStringMonthly(this.paymentAmount)}
                                </div>
                            </div>
                        :
                            null
                        }
                        <span>
                        {this.changeType === "policy"  || this.changeType === "newLevel" ?
                        <span>
                            <div className="font-weight-bold mt-2 text-center">
                            ------------------------------------- Credit Card Policy ---------------------------------------
                            </div>   
                    
                            <div className="ml-4 mt-2"><b>{this.cardLit}</b> 
                                {this.creditCardSetup}
                            </div>
                            <div className="ml-4 mt-2"><b>New Credit Limit:</b> &nbsp;
                                {doubleToStringMonthly(this.newCreditLimitAmt)}</div>
                            <div className="ml-4 mt-2"><b>Credit Card Policy Selected:</b> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                {this.newPaymentPolicy}
                            </div>
                            <div className="ml-4 mt-2 font-weight-bold text-warning">
                                {this.outStandingMsg}
                            </div>
                        </span>
                        :
                            null
                        }
                        </span>
                    </span>
                :
                    null
                }
                         
            {this.state.openFriendModal ?
                <FriendDisplayModal  show={this.state.openFriendModal} 
                    title={this.state.newCarDesc}
                    gameProcess="GameViews"
                    askAFriendInfo={this.askAFriendInfo}
                    friendData={this.state.emptyArr}
                    onClose={() => this.closeFriendModal()} 
                    gameInfo = {() => this.props.gameInfo()}
                    />
            :
                null
            }
         
            </span>
        </Modal.Body>
        <Modal.Footer className="backgroundTopBottom">
            <div className={this.msgClass}>{this.message}</div>
            {this.step === "display" ?
                <span>
                    <Button variant="secondary"  onClick={() => this.changeCreditCardPolicy()} >
                        {this.btnText}
                    </Button>
                </span>
            :
                null
            }
            {this.step === "payment" ?
                <span>
                    <Button className="mr-2" variant="secondary"  onClick={() => this.editFormFields()} >
                        Make a Payment
                    </Button> 
                </span>
            :
                null
            }
            {this.step === "change" ?
                <span>
                    <Button className="mr-2" variant="info"  onClick={() => this.displayFriendModal()} >
                        Ask a Friend
                    </Button>
                    <Button className="mr-2" variant="secondary"  onClick={() => this.editFormFields()} >
                        Submit Change
                    </Button> 
                </span>
            :
                null
            }
            {this.step === "confirm" ?
                <span>
                    <Button className="mr-2" variant="secondary"  onClick={() => this.saveCreditCardPolicy()} >
                        Confirm Change
                    </Button>
                    <Button className="mr-2" variant="secondary"  onClick={() => this.changeCreditCardPolicy()} >
                        Back
                    </Button>
                </span>
            :
                null
            }
             {this.step === "paymentConfirm" ?
                <span>
                    <Button className="mr-2" variant="secondary"  onClick={() => this.saveCreditCardPolicy()} >
                        Confirm Change
                    </Button>
                    <Button className="mr-2" variant="secondary"  onClick={() => this.goBackToPaymentOption()} >
                        Change Pay Amt
                    </Button>
                </span>
            :
                null
            }
            <Button variant="primary"  onClick={() => this.props.onClose("none")}>
                     Close
            </Button>
           
        </Modal.Footer>
        </Modal>
        </>
    }

componentDidMount(){
    this._isMounted = true;
    this.initializeFields();
}
    
saveCreditCardPolicy(){
    if (this.changeType !== "payment"){
        this.reviseConditionsTable();
    }
    this.updateUnlockedFeatures();
    this.updateCreditCardInfoData();
    this.creditReport = determineCreditScore(this.creditCardObj, this.gameData.loanTable, 
        this.gameData.currentGameDate, this.gameData.gameNbrMonths,
        this.timeWizardInfo );
    let returnVal = "complete";
    if (this.changeType === "payment"){
        returnVal = "payment"
    }
   
    this.props.onClose(returnVal, this.creditReport);
}

reviseConditionsTable(){
    this.newConditionsTable = JSON.parse(JSON.stringify(this.gameData.conditionsTable));
    if (!this.creditCardInfo.gameID){
        this.newCreditCardEntry = true;
        var conditionIndx = this.newConditionsTable.findIndex(p => p.condName === "credit-card-unlocked");
        if (conditionIndx !== -1){
            let newConditionsTable = []; 
            //  tried to use splice (instead of for loop) but it was not working.  It was returning only the one
            //  that I wanted to remove (format was .splice(conditionIndx, 1)
            for (let i=0; i<this.gameData.conditionsTable.length; i++){
                if (i !== conditionIndx){
                    let conditionObj = this.gameData.conditionsTable[i];
                    newConditionsTable.push(conditionObj);
                }
            }        
            this.newConditionsTable = newConditionsTable;
        }
    }else{
        this.newCreditCardEntry = false;
    }
}

updateUnlockedFeatures(){  
    if (this.paymentAmount !== 0 && this.state.eventTracker === true){
        this.saveEventTracker();
    }
    this.gameData.currentCash = (+this.gameData.currentCash - this.paymentAmount).toFixed(2);
    if (this.changeType === "payment"){
        //  no update to the unlocked features should be done
    }else{
        this.changeUnlockedFeaturesAndIconTable();
    }
    this.props.setGameInfo(this.gameData, 'gameData');
    this.bodyObj = {
        "currentCash": this.gameData.currentCash,
        "unlockedFeatures": this.gameData.unlockedFeatures,
        "iconTable": this.gameData.iconTable
    };
    const funcName = "updateUnlockedFeatures";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri,
       {method:'PUT', headers: this.state.headers,
       body: JSON.stringify(this.bodyObj)})
       .then(response => {
        if (response.ok){
            response.json().then(data => {
            const output = JSON.parse(data);
            const statusCode = output.statusCode;
            if (statusCode === 200){
               //  successful update of gameData
            }else{
                const errorObj={function: funcName, subProcess: this.state.subProcess, 
                    status: statusCode, message: output.body.message, errorObject: this.bodyObj };
                this.props.processError(errorObj);
            }
        });
        }
    });
}

changeUnlockedFeaturesAndIconTable(){
    const index = 
        this.gameData.unlockedFeatures.findIndex( element => element.featureName === "creditCard");
    let unlockedFeaturesObj = this.gameData.unlockedFeatures[index];
    if (this.acceptDecline === "ineligible"){
        if (this.creditCardInfo.cardLevel){
            unlockedFeaturesObj.level = this.creditCardInfo.cardLevel;
            if (this.creditCardInfo.currentlyActive === true){
                unlockedFeaturesObj.setup = "active";
            }else{
                unlockedFeaturesObj.setup = "inactive";
            }
            this.gameData.unlockedFeatures[index] = unlockedFeaturesObj;
        }else{
            this.gameData.unlockedFeatures.splice(index, 1);
        }
    }else{
        let activeInactive = "inactive";
        if (this.acceptDecline === "accept" || this.acceptDecline === "retain"){
            activeInactive = "active";
        }
        unlockedFeaturesObj.setup = activeInactive;
        this.gameData.unlockedFeatures[index] = unlockedFeaturesObj;
    }
    this.iconTable = this.gameData.iconTable;
    let startIdx = this.iconTable.length - 1;
    for (let i=startIdx; i>=0; i--){
        const iconTable = this.iconTable[i];
        if (iconTable.iconName === "creditCard" ||
            iconTable.iconName === "creditLimitExceeded" ||
            iconTable.iconName === "creditCardReminder"){
            this.iconTable.splice(i,1);
            break;
        }
    }
    this.gameData.iconTable = this.iconTable;
}

updateCreditCardInfoData(){
    if (this.newCreditCardEntry === true){
        this.updateConditionsTable();
    }
    this.determineCreditCardInfo();
    this.setBodyObj();
    this.updateCreditCardInfo();
}

updateConditionsTable() {
    // remove credit-card-unlocked condition 
    this.gameData.conditionsTable = this.newConditionsTable;
    this.props.setGameInfo(this.newConditionsTable, "gameData", "conditionsTable");
    const funcName = "updateConditions";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    // Update conditions table in Mongo
    const bodyObj = { "conditionsTable": JSON.parse(JSON.stringify(this.gameData.conditionsTable)) };
    fetch(uri,
        {
            method: 'PUT', headers: this.state.headers,
            body: JSON.stringify(bodyObj)
        })
        .then(response => {
            if (response.ok){
              response.json().then(data => {
              const output = JSON.parse(data);
              const statusCode = output.statusCode;
              if (output.statusCode === 200){ 
                  // updateConditions Table was successful;
              }else{
                  const errorObj={function: funcName, subProcess: this.state.subProcess, 
                      status: statusCode, message: output.body.message, errorObject: bodyObj};
                  this.props.processError(errorObj);
              }
          });
        }
    });
}

saveEventTracker(){
    const creditCardChangeInfo = {unlockedFeature: "CreditCard",
         cashChg: this.paymentAmount,
         conditionTable: this.newConditionsTable,
         assetTable: this.gameData.assetTable, 
         expenseTable: this.gameData.expenseTable,
         loanTable: this.gameData.loanTable, 
         moodPoints: "0"};
    const dataObject = createEventTrackerUpdateObject("UnlockedFeatures", 
        "SetUpCreditCard", this.gameData, creditCardChangeInfo, this.creditCardInfo);

    const funcName = "saveEventTracker";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri,  
        {
        method:'post',
        headers: this.state.headers,
        body: JSON.stringify(dataObject)
        })
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                       // update of event tracker was successful
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message, errorObject: dataObject};
                        this.props.processError(errorObj);
                    }
                });
            };
        });
}

determineCreditCardInfo(){
    this.gameID = this.gameData._id;
    this.nbrMonths = 1;
    if (this.timeWizardInfo.gameID  &&
        this.timeWizardInfo.status !== "inactive"){
            this.nbrMonths = +this.timeWizardInfo.monthsPerTurn - 1;
    }
    if (this.newCreditCardEntry === true){
        let creditCardObj = findDataObject("creditCardInfo").creditInfo;
        creditCardObj.cardLevel = this.newCardLevel;
        let periodCreditObj = findDataObject("periodCreditCharges").creditInfo;
        periodCreditObj.bgnDate = this.gameData.currentGameDate;
        periodCreditObj.endDate = periodCreditObj.bgnDate;
        if (this.timeWizardInfo.gameID  &&
            this.timeWizardInfo.status !== "inactive"){
                periodCreditObj.endDate = 
                    rollForwardDate(this.gameData.currentGameDate, this.nbrMonths);
        }
        creditCardObj.periodCreditCharges.push(periodCreditObj);
        this.creditCardInfo = creditCardObj;
    }
    let currentlyActive = false;
    if (this.acceptDecline === "accept" || this.acceptDecline === "retain"){
        currentlyActive = true;
        if (this.creditCardInfo.currentlyActive === false){
            this.startDate = this.gameData.currentGameDate;
        }else{
            this.startDate = this.creditCardInfo.creditCardStartDate;
        }
    }
    if (this.paymentAmount > 0){
        // payment amount should be applied to previous month
        const indx = this.creditCardInfo.periodCreditCharges.length - 2;
        this.creditCardInfo.periodCreditCharges[indx].periodAmtPaid = 
            +this.paymentAmount + +this.creditCardInfo.periodCreditCharges[indx].periodAmtPaid;
        const creditCardBalance = 
            (+this.creditCardInfo.totalOutstandingBalance - this.paymentAmount).toFixed(2);
        this.creditCardInfo.totalOutstandingBalance = creditCardBalance.toString();
        let prevCardBalance = 
            (+this.creditCardInfo.prevPeriodOutstandBalance - this.paymentAmount).toFixed(2);
        if (prevCardBalance < 0){
            prevCardBalance = 0;
        }
        this.creditCardInfo.prevPeriodOutstandBalance = prevCardBalance.toString();
        const minPayment = (this.creditCardInfo.prevOutstandBalance * this.minPayPct).toFixed(2);
        const paymentHistory = calculatePaymentHistory(this.creditCardInfo.paymentHistory,
            this.gameData.currentGameDate, this.nbrMonths, minPayment,
            this.paymentAmount, "manualPay");
        this.creditCardInfo.paymentHistory = paymentHistory;
    }
    this.creditCardInfo.paymentPolicyCode = this.newPaymentPolicyCode;
    this.creditCardInfo.currentlyActive = currentlyActive;
    if (this.acceptDecline === "accept"){
        this.creditCardInfo.creditCardStartDate = this.startDate;
        this.creditCardInfo.cardLevel = this.newCardLevel.toString();
        this.creditCardInfo.creditMaxAmount = this.newCreditLimitAmt;
    }
  
}

setBodyObj(){
    let prevPeriodOutstandBalance = "0.00";
    if (this.creditCardInfo.prevPeriodOutstandBalance){
        prevPeriodOutstandBalance = this.creditCardInfo.prevPeriodOutstandBalance;
    }else{
        prevPeriodOutstandBalance = this.creditCardInfo.totalOutstandingBalance;
    }
    let paymentHistoryArr = [];
    if (this.creditCardInfo.paymentHistory){
        paymentHistoryArr = this.creditCardInfo.paymentHistory;
    }
    this.creditCardObj = {
        "gameID": this.gameID,
        "paymentPolicyCode": this.creditCardInfo.paymentPolicyCode,
        "currentlyActive": this.creditCardInfo.currentlyActive,
        "creditCardStartDate": this.creditCardInfo.creditCardStartDate,
        "creditMaxAmount": this.creditCardInfo.creditMaxAmount,
        "totalOutstandingBalance": this.creditCardInfo.totalOutstandingBalance,
        "prevPeriodOutstandBalance": prevPeriodOutstandBalance,
        "totalIntBilled": this.creditCardInfo.totalIntBilled,
        "cardLevel": this.creditCardInfo.cardLevel,
        "lateFeeCount": this.creditCardInfo.lateFeeCount,
        "periodCreditCharges": this.creditCardInfo.periodCreditCharges,
        "paymentHistory": paymentHistoryArr
    };
    this.creditCardInfo = this.creditCardObj;
    this.props.setGameInfo(this.creditCardInfo, "creditCardInfo");
}

updateCreditCardInfo(){
    const funcName = "updateCreditCardInfo";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri,  
        {method:'PUT', headers: this.state.headers, 
        body: JSON.stringify(this.creditCardObj)})
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode === 200){
                    this.props.setGameInfo(output.body, 'creditCardInfo');
                    this.props.checkUnlockedFeatures();
                }else{
                    const errorObj={function: funcName, subProcess: this.state.subProcess, 
                        status: statusCode, message: output.body.message, errorObject: this.creditCardObj};
                    this.props.processError(errorObj);
                }
            });
            }
        });
}
    
}

export default connect(mapStateToProps)(SetupCreditCardModal);
